export default {
  setEngagementTemplates(state, payload) {
    state.engagementTemplates = payload;
  },
};
